export default __webpack_public_path__ + "static/media/307.73e35415.jpg";